import { newsecondaryColor } from "@app/styles";
import styled from "styled-components";

export const RadioContainer = styled.div`
  min-width: 100px;
  label {
    line-height: 20px;
    display: block;
    position: relative;
    padding-left: 28px;
    cursor: pointer;
  }

  input[type="radio"] {
    position: absolute;
    opacity: 0;
  }

  input[type="radio"] + label:before {
    content: "";
    background: #f4f4f4;
    border-radius: 50%;
    border: 1px solid ${newsecondaryColor};
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    margin-right: 8px;
    cursor: pointer;
    transition: all 250ms ease;
    box-sizing: border-box;
  }

  input[type="radio"]:checked + label:before {
    background-color: ${newsecondaryColor};
    border: solid 1px ${newsecondaryColor};
    box-shadow: inset 0 0 0 2px #f4f4f4;
  }

  input[type="radio"]:focus + label:before {
    outline: none;
    border-color: ${newsecondaryColor};
  }

  input[type="radio"] + label:empty:before {
    margin-right: 0;
  }
  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const RadioInformation = styled.span`
  display: block;
  padding-left: 28px;
  font-size: 14px;
  margin-top: 8px;
  opacity: 0.65;
`;
